
export const getClubId = async (ignoreManaged = false) =>
{
  let clubId;
  if (!ignoreManaged)
  {
    clubId = await getManageClubId();
  }
  if (!clubId)
  {
    let clubProfile = JSON.parse(localStorage.getItem('clubProfile'));
    if (clubProfile)
    {
      clubId = clubProfile.id;
    }
  }
  return clubId;
};

export const getManageProfile = async () =>
{
  const jsonProfile = localStorage.getItem('manageClubProfile');
  if (jsonProfile !== 'undefined')
  {
    return JSON.parse(jsonProfile);
  }
  return null;
};
export const getManageClubId = async () =>
{
  return localStorage.getItem('manageClubId');
};

export const setManageClubId = async (clubId) =>
{
  localStorage.setItem('manageClubId', clubId);
}

export const unsetManage = () =>
{
  localStorage.removeItem('manageClubId');
  localStorage.removeItem('manageClubProfile');
}